import { render, staticRenderFns } from "./PaginaListadoRespuestasMuniAprobadas.vue?vue&type=template&id=3f7184f8"
import script from "./PaginaListadoRespuestasMuniAprobadas.vue?vue&type=script&lang=js"
export * from "./PaginaListadoRespuestasMuniAprobadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports